import { FileCode2, FileSpreadsheet, FileText, Image as ImageIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import type { DmsAttachment } from '@erp/shared';
import { Skeleton } from '@/components/ui/skeleton';
import { useDmsPreview } from '@/features/dms/api/use-dms';

export function DmsThumbnail({ attachment }: { attachment: DmsAttachment }): JSX.Element {
  const isImage = attachment.mimeType.startsWith('image/');
  const preview = useDmsPreview(attachment, isImage);
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (preview.data === undefined) {
      setUrl(null);
      return;
    }
    const next = URL.createObjectURL(preview.data);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [preview.data]);

  if (isImage && preview.isPending) {
    return <Skeleton className="h-full w-full rounded-none" />;
  }
  if (isImage && url !== null) {
    return <img src={url} alt="" className="h-full w-full object-cover" />;
  }
  if (attachment.mimeType === 'application/pdf') {
    return <FileText className="h-10 w-10 text-destructive" aria-hidden="true" />;
  }
  if (attachment.mimeType.includes('spreadsheet') || attachment.mimeType === 'text/csv') {
    return <FileSpreadsheet className="h-10 w-10 text-emerald-600" aria-hidden="true" />;
  }
  if (attachment.mimeType.startsWith('text/')) {
    return <FileCode2 className="h-10 w-10 text-muted-foreground" aria-hidden="true" />;
  }
  return <ImageIcon className="h-10 w-10 text-muted-foreground" aria-hidden="true" />;
}
